export default __webpack_public_path__ + "images/0x3f56e0c36d275367b8c502090edf38289b3dea0d.png";